export default [
  {
    key: "given0",
    label: "First Name",
    regex: /^[A-Za-z0-9*'.-s]/,
  },
  {
    key: "given1",
    label: "Middle Name",
    regex: /^[A-Za-z0-9*'.-s]/,
  },
  {
    key: "family",
    label: "Last Name",
    regex: /^[A-Za-z0-9*'.-s]/,
  },
  {
    key: "gender",
    label: "Gender",
    regex: /^\D+$/,
  },
  {
    key: "birthTime",
    label: "Date of birth (MM/DD/YYYY)",
    regex: /^[\d/-]+$/,
  },
  {
    key: "streetAddress",
    label: "Address Line",
    regex: /^[A-Za-z0-9*'.-s]/,
  },
  {
    key: "city",
    label: "City",
    regex: /^\D+$/,
  },
  {
    key: "state",
    label: "State",
    regex: /^\D+$/,
  },
  {
    key: "country",
    label: "Country",
    regex: /^\D+$/,
  },
  {
    key: "postalCode",
    label: "Postal Code",
    regex: /^[\d/-]+$/,
  },
  {
    key: "system",
    label: "Root OID/System",
    regex: /^[A-Za-z0-9'.-s]/,
  },
  {
    key: "value",
    label: "Extension/Value",
    regex: /^[A-Za-z0-9'.-s]/,
  },
  {
    key: "source_code",
    label: "Source Code",
    regex: /^[A-Za-z0-9'.-s]/,
  },
  {
    key: "record_id",
    label: "Record ID",
    regex: /^[A-Za-z0-9'.-s]/,
  },
  {
    key: "golden_id",
    label: "HCM ID/EID",
    regex: /^[A-Za-z0-9'.-s]/,
  },
  {
    key: "telecom",
    label: "Phone Number",
    regex: /^[A-Za-z0-9*'.-s]/,
  },
  {
    key: "email",
    label: "Email",
    regex: /^[A-Za-z0-9*'.-s]/,
  },
  {
    key: "ssn",
    label: "SSN",
    regex: /^[A-Za-z0-9*'.-s]/,
  },
  {
    key: "mbi",
    label: "MBI",
    regex: /^[A-Za-z0-9*'.-s]/,
  },
  {
    key: "hicn",
    label: "HICN",
    regex: /^[A-Za-z0-9*'.-s]/,
  },

  {
    key: "policyNum",
    label: "Policy number",
    regex: /^[A-Za-z0-9*'.-s]/,
  },
  {
    key: "subscriberID",
    label: "Subscriber ID",
    regex: /^[A-Za-z0-9*'.-s]/,
  },
];
